import _mapValues from "lodash/mapValues";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import Utility from "../../Utility/Utility";
import { jsx as _jsx } from "react/jsx-runtime";
export var TokenText = function TokenText(_ref) {
  var text = _ref.text,
    tokens = _ref.tokens,
    format = _ref.format,
    attributes = _ref.attributes;
  var wrappedTokens = _mapValues(tokens, function (value, key) {
    return /*#__PURE__*/_jsx("span", {
      "data-e2e-name": "token_text",
      children: value
    }, key);
  });
  var processedText = Utility.replaceTokens(text, wrappedTokens, false, format);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, attributes), {}, {
    children: typeof processedText !== 'string' && processedText.map(function (item, idx) {
      if (typeof item === 'string') {
        return /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: item
          }
        }, idx);
      } else if ( /*#__PURE__*/React.isValidElement(item)) {
        return /*#__PURE__*/_jsx(item.type, _objectSpread({}, item.props), idx);
      }
      return null;
    })
  }));
};